const userScroll = () => {
  window.addEventListener('scroll', () => {
    const header = document.querySelector('#header');
    const navbar = header.querySelector('.navbar');
    
    if (window.scrollY > 50) {
      header.classList.add('bg-dark');
      header.classList.add('header-sticky');
    } else {
      // Check if the navbar is expanded before removing classes
      const isExpanded = navbar.querySelector('.navbar-collapse').classList.contains('show');
      if (!isExpanded) {
        header.classList.remove('bg-dark');
        header.classList.remove('header-sticky');
      }
    }
  });
}

export default userScroll;
